import React, { useState, useContext } from 'react'
import { useHistory } from 'react-router-dom'
import PropTypes from 'prop-types'
import cn from 'classnames'
import Grid from '../Grid'
import Image from '../Image'
import Typography from '../Typography'
import styles from './PackageItem.module.sass'
import { CustomerContext } from '../../contexts/CustomerContext'
import OrderPackage from '../../models/OrderPackage'
import useLocalStorage from '../../hooks/useLocalStorage'
import preorderIcon from '../../assets/preorder.png'

const PackageItem = ({ packageItem: { id, bannerUrl, name, useNewPackageBuilder, imageUrl },
                       to,renderPlaceholder = false, currentSeason }
) => {
  const { customer, setCustomer } = useContext(CustomerContext)
  const [display, setDisplay] = useState(styles.hidden)
  const history = useHistory()
  const [isUsingAccessCode] = useLocalStorage('isUsingAccessCode')

  const handleSelection = () => {
    const orderPackage = new OrderPackage({
      packageId: id,
      cartId: customer.cart.id,
      isPreviewHidden: !isUsingAccessCode,
    })

    setCustomer({ ...customer, currentOrderPackage: orderPackage })
    history.push(to)
  }

  return (
    <Grid
      item
      container
      xs={11}
      classes={cn(styles.packageItem, display, { [styles.whiteBg]: !useNewPackageBuilder })}
      onClick={handleSelection}
    >
      {renderPlaceholder ? (
        <Image classes={styles.itemImg} src={preorderIcon} onLoad={() => setDisplay(undefined)} />

      ) : (
        useNewPackageBuilder ? (
          <Image classes={styles.itemImg} src={bannerUrl} onLoad={() => setDisplay(undefined)} />
        ) : (
          <>
            <Grid item xs={2}>
              <Image classes={styles.itemImg} src={imageUrl} onLoad={() => setDisplay(undefined)} />
            </Grid>
            <Grid container alignItems="center" item xs={10}>
              <Typography weight={600} classes={styles.typography}>{name}</Typography>
            </Grid>
          </>
        )
      )}
    </Grid>
  )
}

PackageItem.propTypes = {
  packageItem: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    imageUrl: PropTypes.string.isRequired,
    isSeniorPortraits: PropTypes.bool.isRequired,
  }).isRequired,
  to: PropTypes.string.isRequired,
}

export default PackageItem
